<template>
  <naviWrapp
    :borderColor="menuTheme"
    class="wp-navi-links"
    :class="[{ 'has-active-items': anySubIsActive(menu) }, naviClass]"
  >
    <li
      class="link-list"
      v-for="(item, i) in menu"
      :key="i"
      :class="[
        { 'has-childs': item.children && item.children[0] },
        { 'list-link-active': subIsActive(item.url) }
      ]"
    >
      <WpLink
        :url="item.url"
        :id="item.object_id"
        :title="item.title + ' ' + item.description"
        :classname="item.classes + ' link-navi type-' + item.object"
        :target="item.target"
        :type="item.type"
        :ref="'menu-link-' + i"
        v-html="item.title"
      >
        <StyledIcon v-if="icons" v-html="svgIcons.arrow2" />
      </WpLink>
      <wp-navi-links
        v-if="item.children && item.children[0]"
        :menu="item.children"
        :parent="item.ID"
        :depth="menuDepth"
        :class="{ 'has-link-active': subIsActive(item.url) }"
      />
    </li>
  </naviWrapp>
</template>

<script>
import WpLink from "@/components/elements/WpLink";
import WpNaviLinks from "@/components/elements/WpNaviLinks";
import StyledIcon from "@/components/elements/StyledIcon";

import styled from "vue-styled-components";

const naviWrapProps = { borderColor: String };
const naviWrapp = styled("ul", naviWrapProps)``;

import { mapGetters } from "vuex";

export default {
  name: "wp-navi-links",
  props: ["menu", "parent", "depth", "icons"],
  components: {
    WpLink,
    "wp-navi-links": WpNaviLinks,
    StyledIcon,
    naviWrapp
  },
  mounted: function() {
    //this.checkAct();

    const refs = this.$refs;
    const VM = this;
    for (var key in refs) {
      // skip loop if the property is from prototype
      if (!refs.hasOwnProperty(key)) continue;

      var obj = refs[key];
      for (var prop in obj) {
        // skip loop if the property is from prototype
        if (!obj.hasOwnProperty(prop)) continue;
        //console.log(obj[prop].$el)
        VM.observer[key] = new MutationObserver(mutations => {
          for (const m of mutations) {
            const newValue = m.target.getAttribute(m.attributeName);
            VM.$nextTick(() => {
              VM.onClassChange(newValue, m.oldValue);
            });
          }
        });
        VM.observer[key].observe(obj[prop].$el, {
          attributes: true,
          attributeOldValue: true,
          attributeFilter: ["class"]
        });
      }
    }
  },
  data() {
    return {
      homeUrl: window.WPVUE.home_url,
      hasActiveChild: false,
      items: [],
      observer: [],
      test: false,
    };
  },
  methods: {
    onClassChange(newValue, oldValue) {
      //console.log({oldValue, newValue})
      //console.log(this.test = newValue.includes('router-link-active'))
    },
    recurrCheck(menuItems){
      //console.log(menuItems.url, menuItems)
        let urlToCheck = menuItems.url.replace(this.homeUrl, "").replace(/\/$/, "")
        let hasActieItem = this.currentPath === urlToCheck
        if(!hasActieItem && menuItems.children && menuItems.children.length){
          hasActieItem = menuItems.children.some(children => {
            return this.recurrCheck(children)
          })
        }


        return hasActieItem
    },
    anySubIsActive(menu) {
      let isActive = false;
      const VM = this;
      if (menu) {
        isActive = menu.some(element => {
          return VM.recurrCheck(element)
        });
      }
      return isActive
    },
    subIsActive(input) {
      if (
        input === "/" ||
        input === this.homeUrl + "/" ||
        input === this.homeUrl
      ){
        return false;
      }
      const paths = Array.isArray(input) ? input : [input];
      const url = this.$route.path.replace(this.homeUrl, "").replace(/\/$/, "");
      const test = paths.some(path => {
        let path2 = path.replace(this.homeUrl, "").replace(/\/$/, "");
        return url.indexOf(path2) === 0; // current path starts with this path string
      });
      //this.$emit('hasActive', test);
      return test;
    }
  },
  watch: {
    hasActiveChild(val) {
      this.$emit("isChanged", val);
    }
  },
  computed: {
    ...mapGetters(["currentTheme"]),
    currentPath(){
      return this.$route.path.replace(this.homeUrl, "").replace(/\/$/, "")
    },
    menuTheme() {
      let theme = {
        select_color: "#64134a"
      }; 

      if (this.menu.length) {
        theme = this.currentTheme(this.menu[0].object_id);
      }
      return theme.select_color;
    },
    routePatch() {
      return this.$route.path;
    },
    menuDepth() {
      let depth = 1;
      if (this.depth) {
        depth = depth + Number(this.depth);
      }
      return depth;
    },
    naviClass() {
      let classNames = "";
      if (this.menuDepth === 1) classNames += "top-level level-1";
      if (this.menuDepth && this.menuDepth !== 1)
        classNames += "level-" + this.menuDepth;
      if (this.parent) {
        classNames += " has-parent parent-" + this.parent;
      }
      return classNames;
    }
  },
  beforeDestroy() {
    this.observer.forEach(obs => {
      obs.disconnect();
    });
  }
};
</script>
